var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2326(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reverse",
    transform: "scale(-1, 1) translate(-20.46867, 1)",
    fillRule: "evenodd",
    strokeWidth: 1.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "base",
    stroke: "#687577",
    strokeWidth: 1.96,
    fill: "#FFFFFF",
    transform: "translate(9.544306, 13.640148) scale(-1, 1) translate(-9.544306, -13.640148)",
    d: "M10.0487502,27.280295 C8.9249682,27.280295 6.82910962,26.4097863 4.8685559,24.6755964 C1.78871362,21.9319674 0.0544598194,17.9863881 0.116485286,13.8642195 C0.116485286,12.6830586 0.0823173924,11.5804142 0.0522496462,10.518735 C-0.122348289,4.64706831 -0.248427816,0.405813268 6.5099815,0.0285928224 C7.49914201,-0.0280755884 12.8720432,-0.00895853418 14.0754365,0.163094954 C18.1936926,0.756065012 18.6218163,4.87408333 19.0232891,12.0890644 C19.224538,15.7110635 18.9652037,18.1621429 18.183784,20.0397107 C16.0725498,25.0989026 14.2227001,26.7887137 10.2663997,27.26664 C10.194129,27.2748816 10.1214851,27.2794392 10.0487502,27.280295 Z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hookstyle",
    transform: "scale(-1, -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hook",
    transform: "translate(-8.000000, -21.000000) translate(0.000000, 13.000000)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(8.000000, 8.000000) scale(-1, 1) translate(-8.000000, -8.000000)",
    d: "M3.58716581,4.86252597 C3.06706263,4.62380711 2.85229747,4.03585383 3.10747439,3.54929557 C3.36265132,3.06273731 3.99114002,2.86182379 4.5112432,3.10054265 C5.46056455,3.53626565 6.39450266,4.14450585 7.31484578,4.922185 C8.2443698,5.70762188 10.0438875,7.8539425 12.8028208,11.4459993 C13.1408693,11.8861293 13.0335172,12.4992928 12.5630432,12.8155382 C12.0925692,13.1317837 11.4371322,13.0313555 11.0990837,12.5912255 C8.44101017,9.13048544 6.68104531,7.03134029 5.90861111,6.37864246 C5.12699602,5.71818688 4.35258484,5.21384081 3.58716581,4.86252597 Z"
  })))), /*#__PURE__*/React.createElement("line", {
    id: "extracted",
    stroke: "none",
    strokeLinecap: "square",
    x1: 2.72925769,
    y1: 2.87724113,
    x2: 15.6911048,
    y2: 21.3865535
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2326);
export default __webpack_public_path__ + "static/media/23-26.dd1aee6bb8a90848553c16b5fed171f3.svg";
export { ForwardRef as ReactComponent };